export const i18n = {
  namespaced: true,
  state: () => ({
    locales: [ 'es', 'en', 'de', 'fr', 'it', 'pt' ],
    locale: 'es'
  }),

  mutations: {
    SET_LANG(state, locale) {
      if (state.locales.indexOf(locale) !== -1) {
        state.locale = locale
      }
    }
  }
}
